<template>
  <!-- 非会员商品 -->
  <div class="goods-specs">
    <!--线上商品规格展示-->
    <GoodsInfoCell :nameMaxLength="nameMaxLength" name="规格">
      <span class="text" v-if="currentSpecs && currentSpecs.period_type == 'deadline'">
        有效期至{{ currentSpecs.period_value }}
      </span>
      <span class="text" v-if="currentSpecs && currentSpecs.period_type == 'period'">
        有效期{{ currentSpecs.period_value }}天
      </span>
      <img
        class="icon"
        v-if="productCase.case && productCase.case.length > 1"
        :src="goodsThreePoint"
        @click="specTriggerAction()"
      />
    </GoodsInfoCell>
  </div>
</template>
<!-- nameWidth -->
<script>
import GoodsInfoCell from './GoodsInfoCellItem.vue'
export default {
  name: 'GoodsInforSpecsPrice',
  components: { GoodsInfoCell },
  props: {
    productCase: Object,
    currentSpecs: Object,
    nameMaxLength: {
      type: Number,
      default: 2,
    },
  },
  computed: {},

  data() {
    return {
      goodsThreePoint: this.$imageURL.goodsThreePoint,
    }
  },
  methods: {
    specTriggerAction() {
      this.$emit('clickSpecs')
    },
  },
}
</script>

<style scoped lang="scss">
span {
  font-size: 0.4rem;
  line-height: 0.4rem;
}

.icon {
  position: absolute;
  width: 0.5rem;
  top: 0;
  right: 0;
}
</style>
